import * as React from "react";
import { Field } from "formik";
import { useTranslation } from "react-i18next";
import { Input } from "components/bootstrap";
import { loadStreamsDataLakeOptions } from "data-lake/hooks/useDataLakes";
import PaginatedSelect from "components/common/Select/PaginatedSelect";
const StreamSelectField = ({ disabled = false, value = [], onChange }) => {
  const { t } = useTranslation("enterprise_data_lake");
  const selectedStreams = value.join(",");
  const placeholder = t("stream_select.placeholder");
  const handleChange = (selected) => {
    onChange(selected === "" ? [] : selected.split(","));
  };
  return /* @__PURE__ */ React.createElement(Field, { name: "stream_ids" }, ({ name }) => /* @__PURE__ */ React.createElement(Input, { id: name, label: t("stream_select.label") }, /* @__PURE__ */ React.createElement(
    PaginatedSelect,
    {
      placeholder,
      displayKey: "key",
      disabled,
      inputId: "streams-filter",
      value: selectedStreams,
      onLoadOptions: loadStreamsDataLakeOptions,
      multi: false,
      onChange: handleChange
    }
  )));
};
export default StreamSelectField;
